var app = angular.module('leonardo');

var UserService = function (BaseRestService, RestangularProvider, ConfigThemeService, Upload) {
  var service = new BaseRestService('users');

  service.importExcel = function (params) {
    return Upload.upload({
      url: ConfigThemeService.generateURL('/api/2.0/users/import-excel/'),
      arrayKey: '',
      data: {
        account: params.account,
        file: params.file[0].file,
        response_email_recipients: params.response_email_recipients
      }
    });
  };

  service.exportExcel = function (params) {
    return RestangularProvider.all('users').customGET('export-users', params);
  };

  return service;
};

app.factory('UserService', ['BaseRestService', 'Restangular', 'ConfigThemeService', 'UploadBase', UserService]);
